import { render, staticRenderFns } from "./ConfigDescription.vue?vue&type=template&id=8cdbd68e&"
import script from "./ConfigDescription.vue?vue&type=script&lang=js&"
export * from "./ConfigDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports